import { render, staticRenderFns } from "./studioDashboardDaycareStatistic.vue?vue&type=template&id=3dfe1f7e&scoped=true"
import script from "./studioDashboardDaycareStatistic.vue?vue&type=script&lang=js"
export * from "./studioDashboardDaycareStatistic.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardDaycareStatistic.vue?vue&type=style&index=0&id=3dfe1f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe1f7e",
  null
  
)

export default component.exports